import { useEffect, useMemo } from 'react';
import analytics from 'modules/analytics';
import { globalContext } from 'modules/analytics/constants';
import { useSplitClient } from './useSplitClient';
import { FeatureFlag, FFDefaults } from '../featureFlags.generated';

/**
 * NOTE: uses Suspense, make sure to handle it accordingly
 */

export function useSplitFlag<T>(flagName: FeatureFlag, castTo: (arg1: string) => T): T;

export function useSplitFlag(flagName: FeatureFlag): string;

export function useSplitFlag<T = string>(
  flagName: FeatureFlag,
  castTo?: (arg1: string) => T
): T | string {
  const client = useSplitClient();
  const fallbackValue = FFDefaults[flagName];

  const flagValue = useMemo(() => {
    const flag = client != null ? client.getTreatment(flagName) : fallbackValue;
    return flag === 'control' ? fallbackValue : flag;
  }, [client, flagName, fallbackValue]);

  useEffect(() => {
    analytics.addContext(globalContext.workspace.featureFlag(flagName), flagValue);
  }, [flagName, flagValue]);

  return castTo ? castTo(flagValue) : flagValue;
}
